import { render, staticRenderFns } from "./DetailList.vue?vue&type=template&id=64c736e6"
import script from "./DetailList.vue?vue&type=script&lang=js"
export * from "./DetailList.vue?vue&type=script&lang=js"
import style0 from "./DetailList.vue?vue&type=style&index=0&id=64c736e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports